import { ReportConfig } from "../definitions";

const companyWrittenReport: ReportConfig = {
  id: "companyWrittenReport",
  name: "Company Written Report",
  options: [
    { name: "startDate", label: "Start Date", dataType: "date", defaultValue: "$YEAR-01-01" },
    { name: "endDate", label: "End Date", dataType: "date", defaultValue: "$YEAR-$MONTH-$DAY" },
    {
      name: "company",
      label: "Company",
      dataType: "select-dynamic",
      defaultValue: 131,
      optionsDataSource: {
        sql: `
      SELECT ID, [Name]
      FROM dbo.Company
      WHERE IsDeleted = 0
      ORDER BY [Name]`,
        returnType: "options",
      },
    },
  ],
  layout: [
    {
      items: [
        {
          id: "item-1",
          title: "",
          widgetType: "table",
          columns: [
            { name: "Broker", type: "string" },
            { name: "Client", type: "string" },
            { name: "Policy Number", type: "string" },
            { name: "Carrier", type: "string" },
            { name: "Product", type: "string" },
            { name: "Placed", type: "date" },
            { name: "Status", type: "string" },
            { name: "Mode", type: "number", summary: "count" },
            { name: "Premium", type: "currency", summary: "sum", align: "right" },
          ],
          dataSource: {
            sql: `
if @company=''
BEGIN
  PRINT 'You must select a company'
  RETURN
END
ELSE
BEGIN

WITH cte1 AS (
SELECT DISTINCT
    b.FirstName + ' ' + b.lastname AS [Broker],
    CASE WHEN a.FirstName is null then
        ne.FirstName + ' ' + ne.LastName
    ELSE
        a.Firstname+ ' ' + a.lastname
    END AS [Client],
    a.PolicyNumber,
    cr.[Type] AS [Carrier],
    pl.[Name] AS [Product],
    a.EntryDate AS [EntryDate],
    CASE WHEN ap.mode = 'A' THEN 'Annual'
        WHEN ap.mode = 'Q' THEN 'Quarterly'
        WHEN ap.mode = 'SA' THEN 'Semi-Annual'
        WHEN ap.mode = 'M' THEN 'Monthly'
        WHEN ap.mode = '1' THEN 'One Pay'
    END AS [Mode],
    st.Description AS [Status],
    ap.AnnualizedPremium * aa.CommissionPercent AS [Premium],
    aa.CommissionLevel
FROM awu.Application a
    INNER JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    LEFT JOIN awu.ApplicationGroupPolicy gp ON a.id=gp.ApplicationID
    OUTER APPLY (
        SELECT TOP 1 FirstName, LastName
        FROM awu.ExternalInsured
        WHERE a.GroupID=ExternalInsured.ApplicationID
        AND gp.ExternalNumber=ExternalInsured.ExternalNumber
    ) ne
    INNER JOIN awu.ApplicationPremium ap on a.ID = ap.ApplicationID
    INNER JOIN [awu].[ApplicationBroker] [aa] on a.ID = aa.ApplicationID
    INNER JOIN dbo.Broker b on aa.Brokerid = b.ID
    INNER JOIN dbo.Carriertype cr on a.CarrierID = cr.ID
    INNER JOIN awu.[Plan] pl on a.PlanID = pl.ID

WHERE
    a.EntryDate BETWEEN @startDate AND @endDate
    AND st.[ScenarioTypeCode] = 'F'
    AND b.CompanyID = @company
    AND (@_branch = 0 OR a.BranchTypeID = @_branch)
)

SELECT cte1.*, 1 as [Section] FROM cte1

UNION

SELECT null, null, null, null, null, null, null, CAST(COUNT(DISTINCT PolicyNumber) AS varchar), SUM(Premium), null, 2 as [Section]
FROM cte1

ORDER BY Section, EntryDate, PolicyNumber

END
            `,
            returnType: "table",
          },
          options: { summary: false, summaryInData: true, zebraFieldIndex: [2, 1] },
        },
      ],
    },
  ],
};

export default companyWrittenReport;
